module.exports = __webpack_public_path__ + "img/82.7a5e06c0.jpg";